import { V1ThemeImageDetailParamsImageType, V1ThemeImageDetailParamsVariant } from '@sbercloud/typings-iam-auth-client';
import BootcampPNG from '#assets/bootcamp/background.png';
import BootcampWebP from '#assets/bootcamp/background.webp';
import CloudDarkPNG from '#assets/cloud/backgroundDark.png';
import CloudDarkWebP from '#assets/cloud/backgroundDark.webp';
import CloudLightPNG from '#assets/cloud/backgroundLight.png';
import CloudLightWebP from '#assets/cloud/backgroundLight.webp';
import GitversePNG from '#assets/gitverse/background.png';
import GitverseWebP from '#assets/gitverse/background.webp';
import { authV1ApiBaseUrl } from '#constants/global';
import { StorageKey } from '#constants/keys';
import { supportWebP } from './image';
import { isLocalhost } from './isLocalhost';
const isDarkMode = () => window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
export const isDarkTheme = () => {
  if (StorageKey.darkTheme in localStorage) {
    const savedIsDarkTheme = localStorage.getItem(StorageKey.darkTheme) === 'true';
    return savedIsDarkTheme;
  }
  return isDarkMode();
};
const isWepImage = image => image.contentType?.includes('webp');
const findWepImage = images => images.find(isWepImage);
const findBaseImage = images => images.find(img => !isWepImage(img));
function getImage(_ref) {
  let {
    themeId,
    variant,
    imageType,
    format,
    v
  } = _ref;
  const origin = isLocalhost() ? 'https://id-dev.iam.sbercloud.dev' : location.origin;
  return `${origin}${authV1ApiBaseUrl}theme/${themeId}/image/${variant}/${imageType}/${format}?v=${v}`;
}
export const getSavedBackground = clientId => {
  const isSupportWebP = supportWebP();
  const darkMode = isDarkTheme();
  switch (clientId) {
    case 'bootcamp':
      return isSupportWebP ? BootcampWebP : BootcampPNG;
    case 'gitverse':
      return isSupportWebP ? GitverseWebP : GitversePNG;
    default:
      if (darkMode) {
        return isSupportWebP ? CloudDarkWebP : CloudDarkPNG;
      }
      return isSupportWebP ? CloudLightWebP : CloudLightPNG;
  }
};
export const getLoadedImageConfig = (themeConfig, key) => {
  const darkMode = isDarkTheme();
  const lightPath = `${key}Light`;
  const darkPath = `${key}Dark`;
  const requiredBackgroundData = themeConfig[darkMode ? darkPath : lightPath];
  const requiredMode = darkMode ? V1ThemeImageDetailParamsVariant.Dark : V1ThemeImageDetailParamsVariant.Light;
  const alternativeMode = darkMode ? V1ThemeImageDetailParamsVariant.Light : V1ThemeImageDetailParamsVariant.Dark;
  return {
    loadedMode: requiredBackgroundData ? requiredMode : alternativeMode,
    imageData: requiredBackgroundData ?? themeConfig[darkMode ? lightPath : darkPath]
  };
};
export const getCurrentBackground = _ref2 => {
  let {
    clientId,
    themeConfig
  } = _ref2;
  const themeId = themeConfig?.theme?.id ?? '';
  const isSupportWebP = supportWebP();
  const {
    loadedMode,
    imageData: backgroundData
  } = (themeConfig && getLoadedImageConfig(themeConfig, 'background')) ?? {};
  const webpImageData = findWepImage(backgroundData?.representations ?? []);
  const baseImageData = findBaseImage(backgroundData?.representations ?? []);
  const needLoadWebp = isSupportWebP && webpImageData;
  const displayedBackground = needLoadWebp ? webpImageData : baseImageData;
  const imageLink = backgroundData && loadedMode ? getImage({
    themeId,
    variant: loadedMode,
    imageType: V1ThemeImageDetailParamsImageType.Background,
    format: needLoadWebp ? 'webp' : 'base',
    v: displayedBackground?.versionHash
  }) : getSavedBackground(clientId);
  return imageLink;
};
export const getCurrentLogo = themeConfig => {
  if (!themeConfig) {
    return null;
  }
  const themeId = themeConfig.theme?.id ?? '';
  const {
    loadedMode,
    imageData: logoData
  } = getLoadedImageConfig(themeConfig, 'logo');
  const logoHash = findBaseImage(logoData?.representations ?? [])?.versionHash;
  const svgLink = logoData ? getImage({
    themeId,
    variant: loadedMode,
    imageType: V1ThemeImageDetailParamsImageType.Logo,
    format: 'base',
    v: logoHash
  }) : '';
  return svgLink;
};